<template>
  <div v-loading="nalaganjeFormeZaDodajanjePostnegaPredala" class="zgornji-odmik">
    <div v-if="!dosezenaKvotat2Predalov || imaDodatneDomene">
      <p class="navadno-besedilo">
        Ustvarite lahko elektronski predal z domeno t-2.net ali t-2.si s kapaciteto 1 GB. Vsakemu
        elektronskemu predalu dodelite geslo, ki mora vsebovati med 7 in 32 znakov in velike ali male črke
        od A-Z (brez šumnikov), vsaj eno številko (0-9). Geslo bo veljavno samo za prijavo v spletno pošto.
      </p>
      <div class="odmik-zgoraj">
        <el-form label-width="150px" :label-position="formaOrientacija" class="nova-vrstica-forma">
          <el-form-item label="Elektronski naslov" class="barva-pisave-label el-predal-input">
            <el-input
              placeholder="Vnesite poštni naslov"
              @change="GetObstojElektronskegaPredala"
              v-model="postniPredal" type="text"
              id="nov-postni-predal"
              class="input-elektronska-posta">
            </el-input>
            <span class="postavitev-afne">
                @
            </span>
            <el-select
              @change="GetObstojElektronskegaPredala"
              v-model="izbranaEmailDomena"
              placeholder="Izberi"
              class="velikost-domene"
              v-loading="nalaganjeDomen">
              <el-option
                v-for="data in omrezneDomene"
                :key="data"
                :label="data"
                :value="data">
              </el-option>
            </el-select>
          </el-form-item>
          <p class="navadno-besedilo odmik-izjema">
            <el-icon class="el-icon-info" style="padding-top:5px">
            </el-icon>
            Ob vpisu želenega elektronskega naslova se bo preverila njegova razpoložljivost.
            Elektronski naslov lahko vsebuje črke, številke ter znake _ (podčrtaj), . (pika)
            in - (minus).
          </p>
        </el-form>
      </div>
      <div class="odmik-dodajanje-predala">
        <el-form label-width="150px" :label-position="formaOrientacija" class="nova-vrstica-forma">
          <el-form-item label="Naziv za prikaz" class="barva-pisave-label">
            <el-input placeholder="" v-model="nazivZaPrikaz" type="text" id="naziv-za-prikaz"
                      class="input-velikost-naziv">
            </el-input>
          </el-form-item>
          <p class="navadno-besedilo">
            <el-icon class="el-icon-info" style="padding-top:5px">
            </el-icon>
            Naziv bo prikazan pri prejemniku, kateremu boste poslali elektronsko sporočilo.
            Predlagamo vpis imena in priimka ali naziv podjetja.
          </p>
        </el-form>
      </div>
      <div class="odmik-dodajanje-predala">
        <el-form label-width="150px" :label-position="formaOrientacija" class="nova-vrstica-forma">
          <el-form-item label="Geslo" class="barva-pisave-label">
            <el-input placeholder="" type="password" v-model="geslo"
                      value="FakePSW" id="input-geslo" class="velikost-geslo">
              <i v-if="prikazeIkonoGeslo" slot="suffix" class="fa fa-eye-slash"
                 id="ikonaEyeSlashNovoGeslo" @click="PrikazGeslaDodajanjePostniPredal('input-geslo')">
              </i>
              <i slot="suffix" class="fa fa-eye" id="ikonaEyeNovoGeslo"
                 @click="PrikazGeslaDodajanjePostniPredal('input-geslo')" v-else>
              </i>
            </el-input>
          </el-form-item>
          <el-form-item label="Potrdite geslo" class="barva-pisave-label">
            <el-input placeholder="" type="password" v-model="geslo2"
                      value="FakePSW" id="input-ponovite-geslo" class="velikost-ponovite-geslo">
              <i v-if="prikazeIkonoPonoviteGeslo" slot="suffix" class="fa fa-eye-slash"
                 id="ikonaEyeSlashPonoviteGeslo"
                 @click="PrikazGeslaDodajanjePostniPredal('input-ponovite-geslo')">
              </i>
              <i slot="suffix" class="fa fa-eye" id="ikonaEyePonoviteGeslo"
                 @click="PrikazGeslaDodajanjePostniPredal('input-ponovite-geslo')" v-else>
              </i>
            </el-input>
            <validacija-vrednosti
              class="mobile-pozicija"
              :prva-vrednost="geslo"
              :druga-vrednost="geslo2"
              :style=" geslo2 ? 'margin-top:0':'margin-top:-45px'" />
          </el-form-item>
        </el-form>
      </div>
      <div class="pt-2" v-if="validacija !== null">
        <OrderButton
          :disabled="requiredDocumentsLoading || disableButton || validateFieldsNotSuccessful"
          :services="[
            {serviceId: StoritevEnum.EMAIL_LASTNA_DOMENA,
            quantity: 1,
            terminationPointId: Number.parseInt(izbranPrikljucek),
            additionalData: [
              {
                key: 'email',
                value: postniPredal + '@' + izbranaEmailDomena
              },
              {
                key: 'geslo',
                value: geslo
              },
              {
                key: 'nazivZaPrikaz',
                value: nazivZaPrikaz
              }
            ]
          }]"
          class="postavitev-gumb-narocanje"
          style="max-width: 155px"
          :only-modify-free-service="!requiredDocuments"
          @modifyFreeService="GetNovEmail()"
          :service-name="`email predal ${postniPredal}@${izbranaEmailDomena}`"
          @orderConfirmed="GetEmaili(); $emit('osvezitevStraniDodajanje')"
        >
          DODAJ E-PREDAL
        </OrderButton>
      </div>
      <br/>
    </div>
    <div v-else>
      <div style="padding-left: 0; padding-right: 0">
        <p class="navadno-besedilo">
          Porabili ste število elektronskih predalov, ki jih imate na voljo na vašem priključku.
        </p>
        <p class="navadno-besedilo">
          <span>
            Če želite ustvariti nov elektronski predal, morate enega odstraniti ali naročiti dodatne elektronske predale.
          </span>
          <br/>
          <span>
            Za naročilo nas prosim pokličite na
            <b class="primarna-barva">
              {{kontaktniPodatki.T2_SUPPORT_TEL_ST}}
            </b>
            ali nam pišite na
            <b class="primarna-barva">
              {{kontaktniPodatki.T2_INFO_EMAIL}}
            </b>. Na vsakem priključku
            lahko brezplačno koristite največ 5 elektronskih predalov.
          </span>
        </p>
      </div>
    </div>
    <div style="padding-top: 30px" v-if="domeneDomainList.length > 0">
      <div style="padding-top: 20px">
        <hr class="hr-stil">
      </div>
      <div>
        <p class="open-sans-20pt">
          Domain list naslovi
        </p>
      </div>
      <div style="padding-top: 20px">
        <p class="navadno-besedilo">
          Domenski seznam omogoča pošiljanje e-pošte več prejemnikom hkrati – vsem, ki so vključeni v seznam. <b>Za uspešno
          ustvarjanje morate dodati vsaj en elektronski naslov.</b> Vsi prejemniki v seznamu bodo prejeli e-pošto, poslano
          na naslov domenskega seznama.
        </p>
        <p class="navadno-besedilo">
          Pomembno: če ima prejemnik, vključen v seznam, nastavljeno preusmeritev e-pošte, sporočila, poslana na
          domenski seznam, ne bodo posredovana naprej. Dvojne preusmeritve niso podprte.
        </p>
      </div>
      <div style="padding-top: 20px">
        <el-form label-width="150px" :label-position="formaOrientacija">
          <el-form-item label="Domainlist naslov" class="barva-pisave-label">
            <el-input placeholder="" type="text" v-model="domainList" @change="" class="input-elektronska-posta">
            </el-input>
            <span class="postavitev-afne">
              <b>
                @
              </b>
            </span>
            <el-select placeholder="Izberi" class="velikost-domene" v-model="izbranaDomenaDomainList"
                       v-loading="nalaganjeDomen">
              <el-option
                v-for="data in domeneDomainList"
                :key="data"
                :label="data"
                :value="data">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div style="padding-top: 30px">
        <p class="navadno-besedilo">
          <b>
            Vpišite e-naslove, ki jih želite vključiti:
          </b>
        </p>
      </div>
      <div class="odmik-dodajanje-predala">
        <div class="form-group" v-for="(input,i) in inputs" :key="i">
          <div>
            <el-form label-width="" :label-position="formaOrientacija">
              <el-form-item label="" class="barva-pisave-label">
                <el-input placeholder="" type="text" class="velikost-geslo" v-model="input.email">
                </el-input>
                <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg" @click="remove(i)"
                     style="cursor: pointer" class="postavitev-trash">
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div >
        <a class="navadno-besedilo primarna-barva" @click="add()" style="cursor: pointer">
          + Dodaj naslov
        </a>
      </div>
      <div style="padding-top: 35px">
        <div class="odmik-dodajanje-predala">
          <el-button type="primary" class="gumb-potrdi" @click="CreateDomainList">
            SHRANI SPREMEMBE
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Table, TableColumn, Input, Button, Form, Select, Option,
  Collapse, CollapseItem
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna'
import Validacija from '../../../../../assets/js/globalne_funkcije/Validacija'
import {KontaktniPodatkiEnum} from '../../../../../assets/js/Enum/KontaktniPodatkiEnum.js'
import ValidacijaVrednosti from '../../Mojprofil/Varnost/ValidacijaVrednosti.vue'
import OrderButton from '../../../../UIComponents/OrderButton.vue'
import {StoritevEnum} from '../../../../../assets/js/Enum/StoritevEnum'

export default {
  name: 'DodajanjePostnegaPredala',
  computed: {
    StoritevEnum () {
      return StoritevEnum
    },
    validateFieldsNotSuccessful () {
      return !this.validacija.PreverjanjeGeslaEmail(this.geslo) ||
        this.geslo !== this.geslo2 ||
        this.nazivZaPrikaz === ''
    }
  },
  mixins: [PrikazVsebine],
  components: {
    OrderButton,
    'ValidacijaVrednosti': ValidacijaVrednosti,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
    [Form.name]: Form,
    [Select.name]: Select,
    [Option.name]: Option,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  data () {
    return {
      izbranaEmailDomena: '',
      dosezenaKvotat2Predalov: false,
      stNarocenihMailov: 0,
      dodajanjeMailaStatus: '',
      geslo: '',
      seznamEmailov: '',
      geslo2: '',
      nazivZaPrikaz: '',
      formaOrientacija: 'left',
      potencialniMailStatus: '',
      omrezneDomene: [],
      mejnaSirina: 700,
      nalaganjeDomen: false,
      activeName: '0',
      prikazeIkonoPonoviteGeslo: true,
      nalaganjeFormeZaDodajanjePostnegaPredala: false,
      prikazeIkonoGeslo: true,
      postniPredal: '',
      validacija: null,
      stTaba: 't2',
      domainList: '',
      izbranaDomenaDomainList: '',
      inputs: [{
        email: ''
      }],
      domeneDomainList: [],
      kontaktniPodatki: '',
      steviloMoznihMailov: null,
      requiredDocuments: true,
      requiredDocumentsLoading: false,
      disableButton: true,
      imaDodatneDomene: false
    }
  },
  props: {
    izbranPrikljucek: null,
    osvezitevStevec: 0
  },
  watch: {
    osvezitevStevec: function () {
      this.GetMozneDomenePrikljucka()
      this.GetEmaili()
    },
    postniPredal: function () {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.GetObstojElektronskegaPredala()
          this.awaitingSearch = false
        }, 2000)
      }
      this.awaitingSearch = true
    },
    izbranPrikljucek: function () {
      if (this.izbranPrikljucek !== null) {
        this.GetEmaili()
        this.GetMozneDomenePrikljucka()
        this.postniPredal = ''
        this.geslo = ''
        this.geslo2 = ''
        this.nazivZaPrikaz = ''
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.clientAgent = new ClientAgent()
    this.kontaktniPodatki = KontaktniPodatkiEnum
    this.validacija = new Validacija()
    this.GetMozneDomenePrikljucka()
    this.GetEmaili()
  },
  methods: {
    add () {
      this.inputs.push({
        email: ''
      })
    },
    remove (index) {
      this.inputs.splice(index, 1)
    },
    async GetObstojElektronskegaPredala () {
      this.potencialniMailStatus = ''
      if (this.postniPredal.length > 2 && this.izbranaEmailDomena !== '') {
        let documentsRequest = {
          email: this.postniPredal + '@' + this.izbranaEmailDomena,
          idPrikljucek: this.izbranPrikljucek
        }
        try {
          this.requiredDocumentsLoading = true
          let resp = await this.clientAgent.makeRequest('prikljucek/email/exist', documentsRequest, 'GET')
          this.SetObstojElektronskegaPredala(resp)
        } catch (e) {
          this.ErrObstojElektronskegaPredala(e)
        }
      }
    },
    PrikazGeslaDodajanjePostniPredal (id) {
      let element = document.getElementById(id)
      if (element.type === 'password') {
        element.type = 'text'
        if (id === 'input-geslo') {
          this.prikazeIkonoGeslo = false
        } else {
          this.prikazeIkonoPonoviteGeslo = false
        }
      } else {
        element.type = 'password'
        if (id === 'input-geslo') {
          this.prikazeIkonoGeslo = true
        } else {
          this.prikazeIkonoPonoviteGeslo = true
        }
      }
    },
    SetObstojElektronskegaPredala (podatki) {
      this.requiredDocumentsLoading = false
      this.requiredDocuments = podatki.showDocuments
      if (podatki.exist) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Poštni naslov ni na voljo.'
        this.disableButton = true
        paramObvestilo.duration = 2000
        this.ShowWarningMessage(paramObvestilo)
      } else {
        this.disableButton = false
      }
    },
    ErrObstojElektronskegaPredala (e) {
      let paramObvestilo = {}
      paramObvestilo.message = e.message
      paramObvestilo.duration = 2000
      this.ShowWarningMessage(paramObvestilo)
      this.requiredDocumentsLoading = false
      this.disableButton = true
    },
    GetNovEmail () {
      this.dodajanjeMailaStatus = ''
      let idPrikljucek = this.izbranPrikljucek
      if (this.postniPredal.length === 0) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Poštni naslov ni določen.'
        this.ShowWarningMessage(paramObvestilo)
        return false
      }
      if (this.nazivZaPrikaz.length === 0) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Naziv za prikaz ni določen.'
        this.ShowWarningMessage(paramObvestilo)
        return false
      }
      if (!this.validacija.PreverjanjeGeslaEmail(this.geslo)) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Geslo ne ustreza zahtevanim kriterijem.'
        this.ShowWarningMessage(paramObvestilo)
        this.activeName = '1'
        return false
      } else if (this.geslo !== this.geslo2) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Gesli nista enaki.'
        this.ShowWarningMessage(paramObvestilo)
        return false
      } else if (this.izbranaEmailDomena === 't-2.net' || this.izbranaEmailDomena === 't-2.si') {
        let sistemskiRegex = /^(?:root|postmaster|web(?:\.|-)?master|host(?:\.|-)?master|mailer(?:\.|-)?daemon|sysadmin|admin|administrator|support|podpora|help(?:\.|-)?desk|abuse|noc|dns|ftp|smtp|pop|imap|info|kontakt|office|uprava|poslovodstvo|direktor(?:stvo)?|sekretariat|kadrovska|kadri|hr|racunovodstvo|računovodstvo|finance|billing|accounts|place|pla(?:ce|če)|pravna|legal|pr|marketing|prodaja|sales?|servis|service|ponudbe|reklamacije|security|cert|fraud|police|policija|emergency|administratorji|admins?|boss|ceo|cfo|cto|no(?:\.|-)?reply|do(?:n'?t)?(?:\.|-)?reply|system|robot|bot|test|demo|news(?:\.|-)?letter|registracija|sign(?:\.|-)?up|alerts?|notify|notifications?|reports?)$/i
        let lokalniDel = this.postniPredal.split('@')[0]
        if (sistemskiRegex.test(lokalniDel)) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Uporaba sistemskih ali splošnih poštnih naslovov (npr. info, admin...) na domenah t-2 ni dovoljena.'
          this.ShowWarningMessage(paramObvestilo)
          this.postniPredal = ''
          this.izbranaEmailDomena = ''
          this.geslo = ''
          this.geslo2 = ''
          this.nazivZaPrikaz = ''
          return false
        }
      }
      let param = ['idPrikljucek=' + idPrikljucek]
      param.push('email=' + this.postniPredal + '@' + this.izbranaEmailDomena)
      param.push('password=' + this.geslo)
      param.push('naziv=' + this.nazivZaPrikaz)
      this.clientAgent.postWsRequest(this,
        'prikljucek/email/create',
        param,
        null,
        'SetNovEmail',
        'ErrNovEmail')
    },
    SetNovEmail (podatki) {
      if (podatki.status === 1) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Uspešno kreiran poštni predal.'
        this.ShowSuccessMessage(paramObvestilo)
        this.postniPredal = ''
        this.izbranaEmailDomena = ''
        this.geslo = ''
        this.geslo2 = ''
        this.nazivZaPrikaz = ''
        this.GetEmaili()
        this.$emit('osvezitevStraniDodajanje')
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Nepravilnost pri dodajanju.'
        this.ShowWarningMessage(paramObvestilo)
      }
    },
    ErrNovEmail (podatki) {
      this.ShowWarningMessage(podatki)
    },
    GetEmaili () {
      if (this.izbranPrikljucek === null) {
        return false
      }
      this.nalaganjeFormeZaDodajanjePostnegaPredala = true
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/email/seznam',
        param,
        null,
        'SetEmaili',
        'ErrEmaili',
        25000)
    },
    SetEmaili (podatki) {
      this.dosezenaKvotat2Predalov =
        podatki.steviloMoznih <= podatki.seznamEmailov.filter(x => this.validacija.JeT2Domena(x.email)).length
      if (this.dosezenaKvotat2Predalov) {
        this.omrezneDomene = this.omrezneDomene.filter(x => !['t-2.si', 't-2.net'].includes(x))
        this.izbranaEmailDomena = this.omrezneDomene[0]
      }
      this.imaDodatneDomene = podatki.seznamEmailov.find(x => !this.validacija.JeT2Domena(x.email))
      this.seznamEmailov = podatki.seznamEmailov
      this.stNarocenihMailov = podatki.steviloNarocenih
      this.steviloMoznihMailov = podatki.steviloMoznih
      this.nalaganjeFormeZaDodajanjePostnegaPredala = false
      this.postniPredal = ''
      this.geslo = ''
      this.geslo2 = ''
      this.nazivZaPrikaz = ''
    },
    ErrEmaili (podatki) {
      this.ShowWarningMessage(podatki)
    },
    GetMozneDomenePrikljucka () {
      if (this.izbranPrikljucek === null) {
        return false
      }
      this.nalaganjeDomen = true
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      this.clientAgent.postWsRequest(this,
        'prikljucek/email/mozneDomene',
        param,
        null,
        'SetMozneDomenePrikljucka',
        'ErrMozneDomenePrikljucka')
    },
    SetMozneDomenePrikljucka (podatki) {
      this.omrezneDomene = []
      this.domeneDomainList = []
      for (let i = 0; i < podatki.data.vseDomene.length; i++) {
        this.omrezneDomene.push(podatki.data.vseDomene[i])
      }
      for (let i = 0; i < podatki.data.lastneDomene.length; i++) {
        this.domeneDomainList.push(podatki.data.lastneDomene[i])
      }
      this.izbranaEmailDomena = this.omrezneDomene[0]
      this.izbranaDomenaDomainList = this.domeneDomainList[0]
      this.nalaganjeDomen = false
    },
    ErrMozneDomenePrikljucka (podatki) {
      this.ShowWarningMessage(podatki)
    },
    CreateDomainList () {
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      if (this.inputs.length > 0) {
        for (let i = 0; i < this.inputs.length; i++) {
          param.push('domainlist[]=' + this.inputs[i].email)
        }
      } else {
        param.push('domainlist[]=')
      }
      param.push('email=' + this.domainList + '@' + this.izbranaDomenaDomainList)
      this.clientAgent.postWsRequest(this,
        'prikljucek/email/createDomainlist',
        param,
        null,
        'SetCreateDomainList',
        'ErrCreateDomainList')
    },
    SetCreateDomainList (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = 'Domain list uspešno dodan.'
      this.ShowSuccessMessage(paramObvestilo)
      this.$emit('osvezitevStraniDodajanje')
    },
    ErrCreateDomainList (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}
</script>

<style scoped src="../../../../../../static/css/Nastavitve/Email/DodajanjePostnegaPredala.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/ElektronskaPosta/DodajanjePostnegaPredala.vue